import { CopiedGrid } from '../../../../orderState.types';
import { OrderProductGridItem } from '../../../orderProducts.types';
import { getOrderProductKey } from '../../../section/orderProductsSection.utils';
import { OrderProductForGridContainer } from '../../grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';
import { formatNewGrid } from '../../utils/productGrid.utils';
import { CopyOrPasteStatusEnum, GetCopyOrPasteButtonStatusParams } from './copyPaste.types';

const getProductsKeys = (
  product: OrderProductForGridContainer,
  selectedProduct?: OrderProductForGridContainer,
) => {
  const productKey = getOrderProductKey(product);
  const selectedProductKey = selectedProduct && getOrderProductKey(selectedProduct);

  return { productKey, selectedProductKey };
};

const isPastedConsideringQuantity = (
  copiedGrid: CopiedGrid,
  grid: OrderProductGridItem[],
): boolean => {
  if (!copiedGrid?.grid?.length || !copiedGrid.product) {
    return false;
  }

  const gridMap = new Map(grid.map((g) => [g.productSizeId, g]));
  const validCopiedItems = copiedGrid.grid.filter((c) => gridMap.has(c.productSizeId));

  if (!validCopiedItems.length) {
    return false;
  }

  const hasDifferentQuantities = validCopiedItems.some((copied) => {
    const found = gridMap.get(copied.productSizeId)!;
    return (found.orderItemQuantity ?? 0) !== (copied.orderItemQuantity ?? 0);
  });

  return !hasDifferentQuantities;
};

export const getCopyOrPasteButtonStatus = ({
  copiedGrid,
  product,
  grid,
  orderId,
  isPasted,
}: GetCopyOrPasteButtonStatusParams): CopyOrPasteStatusEnum => {
  const { productKey, selectedProductKey } = getProductsKeys(product, copiedGrid.product);

  const copyIsSelected =
    selectedProductKey === productKey && copiedGrid.orderId && copiedGrid.orderId === orderId;

  if (copyIsSelected) {
    return CopyOrPasteStatusEnum.ON_COPY_SELECTED;
  }

  if (isPasted ?? isPastedConsideringQuantity(copiedGrid, grid)) {
    return CopyOrPasteStatusEnum.ON_PASTED_GRID;
  }

  const hasCopiedGrid = copiedGrid.grid?.length > 0;
  const isGridAvailable = hasCopiedGrid
    ? !!formatNewGrid(product, grid, copiedGrid.grid)?.length
    : false;
  const hasPasteAction = isGridAvailable && hasCopiedGrid;

  if (hasPasteAction) {
    return CopyOrPasteStatusEnum.ON_PASTE_ACTION;
  }

  if (!hasCopiedGrid) {
    return CopyOrPasteStatusEnum.ON_COPY_ACTION;
  }

  return CopyOrPasteStatusEnum.ON_UNABLE_TO_PASTE;
};
